import { useNavigate } from 'react-router-dom';
import './CourseCard.css';

export function seededRandom(str, offset = 0) {
  let h = offset * 31;
  for (let i = 0; i < str?.length; i++) h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
  return Math.abs(h % 100);
}

export default function CourseCard({ course, type, compact = false }) {
  const navigate = useNavigate();

    var user = JSON.parse(localStorage.getItem('profile'))
    const courseIndex = user?.result?.coursesTaken.findIndex((item)=>{return (item.courseID===course._id)})
    var progress = user && courseIndex >=0 ? user.result.coursesTaken[courseIndex]?.percentComplete : 0 
    var problems = user && courseIndex >=0 ? user.result.coursesTaken[courseIndex]?.percentCompleteExercises : 0 
    const isCompleted = user && courseIndex >=0 ? user.result.coursesTaken[courseIndex]?.completed : false
    
    problems = problems === undefined ? 0 : problems
    progress = progress === undefined ? 0 : progress
    console.log(course)

    const handleClick = async () => {
        // If new course then nagigate to info card, else go straight to material
        if(type==="new")
            navigate(`/courses/${course._id}`)
        else
            navigate(`/learn/${course._id}`)
    }

  const handleKeyDown = (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(); } };

  const categoryColor = getCategoryColor(course.title);

  return (
    <article
      className={`course-card${compact ? ' course-card--compact' : ''}${isCompleted ? ' course-card--completed' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-label={`View course: ${course.title}`}
    >
      <div className="course-card__accent" style={{ background: categoryColor }} />

      {isCompleted && (
        <div className="course-card__ribbon" aria-label="Course completed">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          Done
        </div>
      )}

      <div className="course-card__body">
        <div className="course-card__meta">
          <span className="course-card__category" style={{ color: categoryColor }}>
            {getCategoryLabel(course.title)}
          </span>
          {!isCompleted && (
            <span className="course-card__duration">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
              {course.duration}
            </span>
          )}
        </div>

        <h3 className="course-card__title">{course.title}</h3>
        <p className="course-card__subtitle">{course.subtitle}</p>

        {!compact && (
          <p className="course-card__details">{course.courseDetailsShort}</p>
        )}

        <div className="course-card__progress">
          <ProgressBar
            label="Progress"
            value={progress}
            color={categoryColor}
          />
          <ProgressBar
            label="Problems"
            value={problems}
            color={categoryColor}
            variant="dashed"
          />
        </div>
      </div>

    </article>
  );
}

function ProgressBar({ label, value, color, variant }) {
  return (
    <div className="progress-bar">
      <div className="progress-bar__header">
        <span className="progress-bar__label">{label}</span>
        <span className="progress-bar__value">{Math.trunc(value)}%</span>
      </div>
      <div className={`progress-bar__track${variant === 'dashed' ? ' progress-bar__track--dashed' : ''}`}>
        <div
          className="progress-bar__fill"
          style={{ width: `${value}%`, background: color }}
          role="progressbar"
          aria-valuenow={value}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`${label}: ${value}%`}
        />
      </div>
    </div>
  );
}

function getCategoryLabel(title) {
  if (title.startsWith('Machine Learning')) return 'Machine Learning';
  if (title.startsWith('Probability')) return 'Probability';
  if (title.startsWith('SAT')) return 'SAT Solvers';
  return 'Course';
}

function getCategoryColor(title) {
  if (title.startsWith('Machine Learning')) return '#4469d8';
  if (title.startsWith('Probability')) return '#2a7a5a';
  if (title.startsWith('SAT')) return '#c05e20';
  return '#6b5ea8';
}
